export const renderSectionsDuration = (duration: number, sections: any) => {
    let unpaidDuration = 0;

    const totalDuration = Number(duration) || 0;
    
    sections?.forEach((section: any) => {
        if (section?.payCode?.hourType === "unpaid") {
            unpaidDuration += (Number(section?.duration) || 0);
        }
    });

    let totalMinutes = Math.floor(totalDuration - unpaidDuration) / 60;

    if (isNaN(totalMinutes)) return "0m";

    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);

    const hoursPart = hours > 0 ? `${hours}h` : "";
    const minutesPart = minutes > 0 ? `${minutes}m` : "";

    return `${hoursPart} ${minutesPart}`.trim() || "0m";
};